// FEAST MOMENT screen markup. Story card → optional one-question quiz → badge.
// The body is rendered by the controller (feast.ts) into #feastBody.
import { icon } from '../ui/icons';

export const feastHTML = /* html */ `
<div id="screenFeast" class="feast-screen hidden">
  <button class="btn secondary back" id="feastBackBtn" type="button" style="width:auto;padding:10px 16px;">← Home</button>
  <div class="content-head">
    <div class="content-title">${icon('sparkle')} Today's Feast</div>
    <div class="content-sub" id="feastSub"></div>
  </div>
  <div id="feastBody" class="feast-body"></div>
  <div id="feastConfetti" class="ri-confetti feast-confetti" aria-hidden="true"></div>
</div>`;
